import { useEffect, useState } from "react";
import { FaUser } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { FormControl, FormHelperText, IconButton, InputAdornment, TextField } from "@mui/material";
import { Close, Save, Visibility, VisibilityOff } from "@mui/icons-material";
import UserImage from "../../../assets/Images/user_Image.png"
import Popup from "reactjs-popup";
import MultiSelect from "../../Commen_Component/Popup/MultiSelect";
import { DocType, InputType, PageEnums } from "../../../_enums/enum.services";
import { commanServicer } from "../../Commen_Services/common.services";
import { useLoading } from "../../Loader/LoadingContext";
import { userServicer } from "../../Commen_Services/user.services";
import customToast from "../../Commen_Component/Toast/CustomToast";
import "./user.css";

interface FormData {
    firstName: string;
    lastName: string;
    mobileNo: string;
    emailId: string;
    company: string;    
    userId: string;
    userName: string;
    password: string;
    confirmPassword: string;
    selectRoute: string;
    isActive: boolean;
    avatar: string | null;
}

export default function UserForm() {
    const ALLOWED_TYPES = ["image/png", "image/jpg", "image/jpeg"];
    const MIN_FILE_SIZE = 5 * 1024;
    const MAX_FILE_SIZE = 5 * 1024 * 1024;
    const { pageId } = useParams<{ pageId: string }>();
    const { action } = useParams<{ action: string }>();
    const [isViewData, setIsViewdata] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const navigate = useNavigate();
    const { setLoading } = useLoading();
    const [selectedImage, setSelectedImage] = useState<any>(null);
    const [formData, setFormData] = useState<FormData>({
        firstName: "",
        lastName: "",
        mobileNo: "",
        emailId: "",
        company: "",
        userId: "",
        userName: "",
        password: "",
        confirmPassword: "",
        selectRoute: "",
        isActive: false,
        avatar: "",
    });
    const [error, setError] = useState({
        firstName: "",
        lastName: "",
        mobileNo: "",
        emailId: "",
        company: "",
        userId: "",
        userName: "",
        password: "",
        confirmPassword: "",
        selectRoute: "",
        isActive: false,
        avatar: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [documentList, setDocumentList] = useState<any[]>([]);

    useEffect(() => {
        if (Number(pageId) > 0) {
            loadData();
        }
    }, []);


    const loadData = async () => {
        const userData = await userServicer.GetUserDetailById(pageId);

        if (userData.status === true) {

            const fullName = userData.data?.user?.empName || "";
            const nameParts = fullName.trim().split(" ");

            const firstName = nameParts[0] || "";
            const lastName = nameParts.slice(1).join(" ") || "";

            const routeIds = userData.data?.userWiseCompany
                ?.map((x: any) => x.routeId)
                ?.filter(Boolean)
                ?.join(",") || "";

            const companyIds = userData.data?.userWiseCompany
                ?.map((x: any) => x.companyId)
                ?.filter(Boolean)
                ?.join(",") || "";

            setFormData({
                firstName: firstName,
                lastName: lastName,
                mobileNo: userData.data?.user?.mobileNo || "",
                emailId: userData.data?.user?.email || "",
                userName: userData.data?.user?.userName || "",
                company: companyIds,
                userId: userData.data?.user?.id?.toString() || "",
                password: "",
                confirmPassword: "",
                selectRoute: routeIds,
                isActive: userData.data?.user?.isActive || false,
                avatar: null,
            });

            const documentList = userData.data?.documentDetails || [];

            const profileImage = documentList.find(
                (item: any) =>
                    item.documentTypeId === DocType.EmployeeProfile
            );

            setSelectedImage(profileImage?.documentPath || null);
        }
    };


    const handleInputChange = (e: any) => {
        const { name, value, type } = e.target;
        const cleaned = value.trim();
        const inputElement = e.target as HTMLInputElement;

        const updatedFormData = {
            ...formData,
            [name]: type === "checkbox" ? inputElement.checked : value,
        };
        setFormData(updatedFormData);

        const validators: Record<string, (v: string) => string | null> = {
            firstName: (v) => (v === "" ? "Please enter a valid first name" : null),
            lastName: (v) => (v === "" ? "Please enter a valid last name" : null),
            mobileNo: (v) => {
                const digits = v.replace(/\D/g, "");
                return digits.length !== 10 ? "Please enter a valid mobile number" : null;
            },
            emailId: (v) =>
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)
                    ? null
                    : "Please enter a valid email",

            password: (v) => {
                if (v === "") return null;
                const strongPass =
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
                if (!strongPass.test(v))
                    return "Password must contain uppercase, lowercase, number, special char and minimum 8 characters.";

                setError((prev) => ({
                    ...prev,
                    confirmPassword:
                    updatedFormData.confirmPassword !== "" &&   
                    updatedFormData.confirmPassword !== v
                    ? "Passwords do not match."
                    : "",
                }));

                return null;
            },

            confirmPassword: (v) => {
                if (v === "") return null;
                    if (v !== updatedFormData.password) return "Password and Confirm Password must be the same.";
                return null;
            },
        };

        const errorMsg = validators[name]?.(cleaned) ?? "";

        setError((prev) => ({
            ...prev,
            [name]: errorMsg,
        }));
    };


    const handleProfileImageUpload = (e: any, documentType: any) => {
        const file = e.target.files[0];

        if (!file) return;

        if (!ALLOWED_TYPES.includes(file.type)) {
            setError((prev: any) => ({
                ...prev,
                avatar: "Only PNG, JPG and JPEG are allowed.",
            }));

            e.target.value = "";
            return;
        }

        if (file.size < MIN_FILE_SIZE || file.size > MAX_FILE_SIZE) {
            setError((prev: any) => ({
                ...prev,
                avatar: "Minimum 5 KB and Maximum 5 MB is allowed.",
            }));

            e.target.value = "";
            return;
        }

        setError((prev: any) => ({
            ...prev,
            avatar: "",
        }));

        setSelectedImage(URL.createObjectURL(file));

        setDocumentList([
            {
                fileData: file,
                docType: documentType,
                documentName: file.name,
            },
        ]);
    };

    const handleSave = async (event: any) => {
        event.preventDefault();

        const IsValid = validateField();
        if (!IsValid) {
            customToast.error("Please fill required fields");
            return;
        }

        try {
            setLoading(true);

            let Objlist: any = [];

            await Promise.all(
                documentList.map(async (file1: any) => {
                    let obj2: any = {};
                    let file = file1.fileData;

                    const d2 = new Date();
                    let ImageName = `${d2.getTime()}_${file.name}`;
                    let abpath = "AdminPortal/Employee/";

                    let Val1 = await commanServicer.UploadImage(abpath, ImageName, file);

                    if (Val1) {
                        obj2.documentName = file.name;
                        obj2.documentTypeId = file1.docType;
                        obj2.documentPath = Val1;
                        Objlist.push(obj2);
                    }
                })
            );


            const companyIds = formData.company
                .split(",")
                .filter((x) => x !== "");

            const arr = companyIds.map((companyId: string) => ({
                userId: formData.userId !== "" ? Number(formData.userId) : 0,
                employeeId: formData.userId !== "" ? Number(formData.userId) : 0,
                companyId: Number(companyId),
            }));


            const payload = {
                user: {
                    id: formData.userId !== "" ? Number(formData.userId) : 0,
                    empName: formData.firstName + " " + formData.lastName,
                    email: formData.emailId,
                    userName: formData.userName,
                    password: formData.password,
                    mobileNo: formData.mobileNo,
                    confirmPassword: formData.confirmPassword,
                    isActive: formData.isActive === true,
                    roleId: 2,
                    employeeId: formData.userId !== "" ? Number(formData.userId) : 0,
                    companyId: formData.company,
                    can_update_price_slab: true,
                    hasFullRights: false,
                    routeIds: formData.selectRoute,
                },

                userWiseCompany: arr,
                documentDetails: Objlist,
            };

            const { data: result } = await userServicer.createorupdateuser(payload);

            if (result?.status === true) {
                customToast.success(result.message);
                navigate(`/Report/view/${PageEnums.UserList}`);
            } else {
                customToast.error(result.message);
            }
        } catch (err) {
            customToast.error("API Failed");
        } finally {
            setLoading(false);
        }
    };


    const validateField = (): boolean => {
        const cleaned = (v: string) => v?.trim() ?? "";

        const rules: Record<string, (v: string) => string | null> = {
            firstName: (v) =>
                v === "" ? "Please enter a valid first name" : null,

            lastName: (v) =>
                v === "" ? "Please enter a valid last name" : null,

            userName: (v) =>
                v === "" ? "Please enter a valid user name" : null,

            mobileNo: (v) => {
                const digits = v.replace(/\D/g, "");
                return digits.length !== 10
                    ? "Please enter a valid mobile number"
                    : null;
            },

            emailId: (v) =>
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)
                    ? null
                    : "Please enter a valid email",

            company: (v) =>
                v === "" ? "Please select a company" : null,

            password: (v) => {

                if (Number(pageId) > 0 && v === "") {
                    return null;
                }

                if (v === "") {
                    return "Please enter a password";
                }

                const strongPass =
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

                if (!strongPass.test(v)) {
                    return "Password must contain uppercase, lowercase, number, special char and minimum 8 characters.";
                }

                return null;
            },

            confirmPassword: (v) => {

                if (Number(pageId) > 0 && formData.password === "" && v === "") {
                    return null;
                }

                if (v === "") {
                    return "Please enter confirm password";
                }

                if (v !== formData.password) {
                    return "Passwords do not match.";
                }

                return null;
            },
        };

        let isValid = true;
        const newErrors: Record<string, string> = {};

        for (const key in rules) {
            const fieldValue = cleaned((formData as any)[key]);
            const error = rules[key](fieldValue);

            if (error) {
                isValid = false;
                newErrors[key] = error;
            }
        }

        setError((prev) => ({
            ...prev,
            ...newErrors,
        }));

        return isValid;
    };


    const handleMouseDownPassword = (event: any) => {
        event.preventDefault();
    };
    const handleClickShowPassword = () => setShowPassword(!showPassword);

    const handleClose = () => {
        setShowConfirmation(false);
    };

    const handleConfirmExit = () => {
        navigate("/Report/view/28");
    };

    const handleMultiSelectChange = (
        name: string,
        headerName: string,
        selected: any[]
    ) => {
        let inputData: any[] = [];
        for (var vx = 0; vx < selected.length; vx++) {
            inputData.push(selected[vx].OptionID);
        }
        let inputIds = inputData.map(a => a).join(",")

        setFormData((prev) => ({
            ...prev,
            [name]: inputIds,
        }));
        setError((prev) => ({ ...prev, [name]: "" }))
    };

    return (
        <div>
            <div className="shadow">
                <div className="bg-line">
                    <span className="bg-head"><FaUser /> &nbsp;{Number(pageId) > 0 && action !== 'view' ? <>Update </> : isViewData ? <>View</> : <>Add </>} Employee</span>
                </div>
                <hr className="colorgraph" />
            </div>
            <div className="form-container">
                <div className="form-wrapper">
                    <div className="form-left">
                        <div className="avatar-section">
                            <div className="avatar-wrapper">
                                {selectedImage ? (
                                    <img
                                        src={selectedImage}
                                        width="100"
                                        className="rounded-circle imaje"
                                        alt="Selected"
                                    />
                                ) : (
                                    <img
                                        src={UserImage}
                                        width="100"
                                        className="rounded-circle imaje"
                                        alt="Default"
                                    />
                                )}
                            </div>
                            <label htmlFor="avatar-input" className="upload-button" >
                                Upload
                            </label>
                            <input
                                id="avatar-input"
                                type="file"
                                className="upload-input"
                                accept=".png,.jpg,.jpeg"
                                onChange={(event) =>
                                    handleProfileImageUpload(event, DocType.EmployeeProfile)
                                }
                            />

                            {error.avatar && (
                                <span
                                    style={{
                                        color: "red",
                                        fontSize: "10px",
                                    }}
                                >
                                    {error.avatar}
                                </span>
                            )}
                        </div>
                    </div>

                    <div className="form-right">
                        <div className="form-grid">
                            <div className="form-group">
                                <TextField
                                    id="standard-basic"
                                    variant="standard"
                                    name="firstName"
                                    value={formData.firstName}
                                    label="First Name"
                                    onChange={handleInputChange}
                                    //focused={!!inputs.employeeCode}
                                    focused={!!formData.firstName}
                                    error={!!error.firstName}
                                    helperText={error.firstName}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.firstName ? 'red' : undefined
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.firstName ? 'red' : undefined
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.firstName ? '9px' : '12px',

                                        },
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                <TextField
                                    id="standard-basic"
                                    variant="standard"
                                    name="lastName"
                                    value={formData.lastName}
                                    label="Last Name"
                                    onChange={handleInputChange}
                                    //focused={!!inputs.employeeCode}
                                    focused={!!formData.lastName}
                                    error={!!error.lastName}
                                    helperText={error.lastName}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.lastName ? 'red' : undefined
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.lastName ? 'red' : undefined
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.lastName ? '9px' : '12px',

                                        },
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                <TextField
                                    id="standard-basic"
                                    variant="standard"
                                    name="mobileNo"
                                    value={formData.mobileNo}
                                    label="Mobile No."
                                    onChange={handleInputChange}
                                    //focused={!!inputs.employeeCode}
                                    focused={!!formData.mobileNo}
                                    error={!!error.mobileNo}
                                    helperText={error.mobileNo}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.mobileNo ? 'red' : undefined
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.mobileNo ? 'red' : undefined
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.mobileNo ? '9px' : '12px',

                                        },
                                    }}
                                />
                            </div>

                            {/* Row 2 */}

                            <div className="form-group">
                                <TextField
                                    id="standard-basic"
                                    variant="standard"
                                    name="emailId"
                                    value={formData.emailId}
                                    label="Emial Id"
                                    onChange={handleInputChange}
                                    //focused={!!inputs.employeeCode}
                                    focused={!!formData.emailId}
                                    error={!!error.emailId}
                                    helperText={error.emailId}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.emailId ? 'red' : undefined
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.emailId ? 'red' : undefined
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.emailId ? '9px' : '12px',

                                        },
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                <FormControl focused={!!formData.company} variant="standard" sx={{ minWidth: 120, }}>
                                    <MultiSelect
                                        name="company"
                                        headerName={"Company"}
                                        label={"Company"}
                                        autoSearchKey={"GetCompanyList"}
                                        selectedValues={formData.company}
                                        onChange={handleMultiSelectChange}
                                        fieldType={InputType.MultiSelect}
                                        autoFocus={false}
                                    />
                                    {error.company ? (
                                        <FormHelperText sx={{ color: 'red', fontSize: 9 }}>{error.company}</FormHelperText>
                                    ) : (
                                        <FormHelperText sx={{ color: 'white', fontSize: 9 }}>&nbsp;</FormHelperText>
                                    )}
                                </FormControl>
                            </div>
                            <div className="form-group">

                                <FormControl focused={!!formData.selectRoute} variant="standard" sx={{ minWidth: 120, }}>
                                    <TextField
                                        id="standard-basic"
                                        variant="standard"
                                        name="userName"
                                        value={formData.userName}
                                        label="User Name"
                                        onChange={handleInputChange}
                                        focused={!!formData.userName}
                                        error={!!error.userName}
                                        helperText={error.userName}
                                        InputProps={{
                                            readOnly: isViewData,
                                            style: {
                                                color: "var(--body-main-dark-color)",
                                                fontSize: "14px",
                                                borderColor: error.userName ? "red" : undefined,
                                            },
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                color: "var(--body-main-dark-color)",
                                                fontSize: "12px",
                                                borderColor: error.userName ? "red" : undefined,
                                            },
                                        }}
                                        FormHelperTextProps={{
                                            style: {
                                                fontSize: error.userName ? "9px" : "12px",
                                            },
                                        }}
                                    />
                                </FormControl>


                            </div>

                            <div className="form-group">

                                <TextField
                                    label="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    variant="standard"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    fullWidth
                                    focused={!!formData.password}
                                    error={!!error.password}
                                    helperText={error.password}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.password ? 'red' : undefined,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                    sx={{
                                                        paddingRight: '18px',
                                                        marginLeft: '8px',
                                                        '& svg': {
                                                            fontSize: '10px',
                                                        },
                                                    }}
                                                >
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.password ? 'red' : undefined,
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.password ? '9px' : '12px',
                                        },
                                    }}
                                />

                            </div>

                            <div className="form-group">
                                <TextField
                                    label="Confirm Password"
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    variant="standard"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleInputChange}
                                    fullWidth
                                    focused={!!formData.confirmPassword}
                                    error={!!error.confirmPassword}
                                    helperText={error.confirmPassword}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.confirmPassword ? 'red' : undefined,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                    sx={{
                                                        paddingRight: '18px',
                                                        marginLeft: '8px',
                                                        '& svg': {
                                                            fontSize: '10px',
                                                        },
                                                    }}
                                                >
                                                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.confirmPassword ? 'red' : undefined,
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.confirmPassword ? '9px' : '12px',
                                        },
                                    }}
                                />
                            </div>


                        </div>

                        <div className="checkbox-group">
                            <input
                                id="isActive"
                                type="checkbox"
                                name="isActive"
                                checked={formData.isActive}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="isActive">Is Active</label>
                        </div>


                        <div className="form-actions">
                            {action !== 'view' && (
                                <button
                                    className={`btn123 ${isViewData ? 'inactive' : ''}`}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        handleSave(event);
                                    }}
                                    style={{ paddingRight: 12, height: '30px' }}
                                >
                                    <Save />&nbsp;{Number(pageId) > 0 ? <>Update</> : <>Save</>}
                                </button>
                            )}
                            &nbsp;
                            <button
                                className={`btn123`}
                                onClick={() => { setShowConfirmation(true) }}
                            >
                                <Close />&nbsp;Close
                            </button>

                            {showConfirmation && (
                                <Popup
                                    contentStyle={{ height: 105, width: 275, padding: 0 }}
                                    position='top center'
                                    open={showConfirmation}
                                    onClose={() => setShowConfirmation(false)}
                                >
                                    <div className="confirmation-modal">
                                        <p>Are you sure you want to exit? <br />(Any unsaved changes will be lost.)</p>
                                        <div className="canel_btns">
                                            <button className="btn123" style={{ marginRight: 10 }} onClick={handleClose}>Cancel</button>
                                            <button className="btn123" style={{ marginLeft: 10 }} onClick={handleConfirmExit}>Yes, Exit</button>
                                        </div>
                                    </div>
                                </Popup>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
